const saveEvent = async (event) => {
  try {
    const id = "mock-event-id-123"; // you can generate a random string if you want
    const now = new Date();

    return {
      status: "success",
      id,
      savedEvent: {
        ...event,
        createdAt: now.toISOString() // store as ISO string
      }
    };
  } catch (error) {
    return {
      status: "failed",
      error: error.message
    };
  }
};

/**
 * Place event.
 *
 * @param {object} event - The event object to be saved.
 * @return {Promise} A promise that resolves with the mock save result.
 */
export function placeEvent(event) {
  return new Promise((resolve) => resolve(saveEvent(event)));
}
